import { Button } from "primereact/button";

export let tarifColumns = [
    {
        attr: "country_guid",
        label: "Страна",
        type: 3,
        opt: 5,
        hidden: false,
        optionLabel: "country",
        optionValue: "guid",
        editor: true,
        body: (row, column) => {
            return <img src={"https://onza-api.ibm.kg" + row?.flag} width={28} height={18} />
        }
    },
    {
        attr: "deliver_time",
        label: "Время доставки",
        type: 1,
        filter: false,
        editor: true,
        body: (row, column) => {
            return <div>
                {
                    row.delivery_time_from + "-" +
                    row.delivery_time_to
                } рабочих дней
            </div>
        }
    }, {
        attr: "cost",
        label: "Стоимость",
        type: 2,
        editor: true,
        filter: true,
    }, {
        attr: "min_cost",
        label: "Мин стоимость",
        type: 0,
        editor: true,
        filter: true,
    }, {
        attr: "sv_weight_cost",
        label: "SV weight cost",
        type: 0,
        editor: true,
        filter: true,
    }, {
        attr: "v_weight",
        label: "V weight",
        type: 0,
        editor: true,
        filter: true,
    }, {
        attr: "zone",
        label: "zone",
        type: 0,
        editor: true,
        filter: true,
    }, {
        attr: "routing",
        label: "Маршрут",
        type: 1,
        editor: true,
        filter: true,
    }, {
        attr: "start_date",
        label: "Дата начала",
        type: 4,
        editor: true,
        filter: true,
        body: (row, field) => {
            let text = ''

            if (row[field.field]) {
                text = new Date(row[field.field]).toLocaleDateString()
            }

            return <>{text}</>
        }
    }, {
        attr: "end_date",
        label: "Дата конца",
        type: 4,
        editor: true,
        filter: true,
        body: (row, field) => {
            let text = ''

            if (row[field.field]) {
                text = new Date(row[field.field]).toLocaleDateString()
            }

            return <>{text}</>
        }
    }
]